<template>
	<div @dragenter.prevent="toggleActive" @dragleave.prevent="toggleActive" @dragover.prevent
		@drop.prevent="toggleActive" :class="{ 'active-dropzone': active }" class="dropzone position-relative">
		<div class="mb-0"><i class="display-4 text-muted ri-upload-cloud-2-fill"></i></div>

		<h5 class="mb-0">{{ title ? title : getLangValue('upload.title1') }}</h5>
		<div v-if="info" class="text-muted fs-12">{{ info }}</div>
		<div v-else>
			<div v-if="limit" class="text-muted fs-12">{{ accept == '.png,.jpeg,.jpg,' ?
				(currentTab ==1 ? getLangValueByKey('upload.typeImage'): getLangValueByKey('upload.typeImage', 'en') ) :
				(currentTab ==1 ? getLangValueByKey('upload.type'): getLangValueByKey('upload.type', 'en')) }} {{ currentTab ==1 ? getLangValueByKey('upload.limit1'):  getLangValueByKey('upload.limit1', 'en')}}{{ limit }}</div>
		</div>
		<label :for="iptId" class="bg-light text-dark stretched-link">{{  currentTab ==1 ? getLangValueByKey('upload.btn'): getLangValueByKey('upload.btn', 'en') }}</label>
		<input type="file" :id="iptId" onblur="this.value=''" class="dropzoneFile btn btn-primary" :accept="accept" />
	</div>
</template>

<script>
import { ref } from 'vue';
import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
import i18n from "@/i18n"
export default {
	name: 'dropzone',
	props: {
		iptId: {
			type: String,
			default: 'dropzoneFile'
		},
		accept: {
			type: String,
			default: '*'
		},
		limit: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		info: {
			type: String,
			default: ''
		},
		currentTab:{
			type: Number,
            default: i18n.global.locale == 'en'? 2: 1
		},
	},
	setup() {
		const active = ref(false);
		const toggleActive = () => {
			active.value = !active.value;
		};
		return { active, toggleActive };
	},
	methods: {
		getLangValue,
		getLangValueByKey
	}
};
</script>
<style>
.stretched-link::after {
	z-index: 0;
}
</style>
